import { Component, Input, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit {
  @Input() labels: string[] = [];
  @Input() datasets = [];
  @Input() chartSize = 200;
  @Input() usage = 0; //TODO: remove usage from chart, make it two components
  @Input() showUsage = false;
  window = window;
  doughnutChartType: ChartType = 'doughnut';

  constructor() { }

  ngOnInit(): void {
  }

}
